import PrivacyContainerGreek from "../components/pageComponents/PrivacyComps/PrivacyContainerGreek";
import classes from "../../../styles/Privacy.module.css";
const Privacy = () => {
    return (
        <div><PrivacyContainerGreek /></div>
    )
}
export default Privacy;